import { DatasetBase, OnlineStorage, DatasetType } from "@tblabs/storage";
import { Line, Button, Snack } from "@tblabs/truffle";
import { Bold } from "../Components/Bold";
import { DangerButton } from "../Components/DangerButton";
import { PaginetedTable } from "../Components/PaginetedTable";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { MetadataViewBox } from "./MetadataViewBox";
import { Page } from "./Page";


export class DatasetViewPage extends Page
{
    private dataset!: DatasetBase;

    constructor(private _storage: OnlineStorage, private datasetName: string)
    {
        super(datasetName + " view");

        this.Content(async () =>
        {
            const metadata = await this._storage.GetDatasetMetadata(this.datasetName);

            switch (metadata.Type)
            {
                case DatasetType.Object:
                    this.dataset = await this._storage.GetObjectDataset(this.datasetName);
                    break;
                case DatasetType.Picture:
                    this.dataset = await this._storage.GetPictureDataset(this.datasetName);
                    break;
                case DatasetType.File:
                    this.dataset = await this._storage.GetFileDataset(this.datasetName);
                    break;
                case DatasetType.Text:
                    this.dataset = await this._storage.GetTextDataset(this.datasetName);
                    break;
                default:
                    throw new Error("Invalid dataset type");
            }

            const itemsIds = await this.dataset.GetAllIds();

            this.body.Append(
                new Panel([new Bold(this.datasetName), " dataset"], [
                    "Of ", new Bold(metadata.Type), " type in ", new Bold(this._storage.DatabaseDir), " database",
                    new Line().Opacity(0.7),
                    new DangerButton("Drop").OnClick(async () => await this.DropDataset()),
                    new DangerButton("Delete").OnClick(async () => await this.DeleteDataset()).MarginLeft(12),
                ]),
                new MetadataViewBox(this.datasetName, metadata),
                new Panel("Items", [
                    new PaginetedTable(itemsIds)
                        .AddColumn("Id", x => x)
                        .AddColumn("Options", x => new Button("View").OnClick(() => window.location.hash = `admin/dataset/${this.datasetName}/${x}/view`))
                        .Build(),
                    new PrimaryButton("Add Item").OnClick(() => window.location.hash = `admin/dataset/${this.datasetName}/add`).MarginTop(12),
                ])
            );
        });
    }

    private async DropDataset(): Promise<void>
    {
        if (confirm("Are you sure you want to drop this dataset?"))
        {
            await this.dataset.Drop();
            new Snack("Dataset dropped", "Refresh page to see changes.");
        }
    }

    private async DeleteDataset(): Promise<void>
    {
        if (confirm("Are you sure you want to delete this dataset?"))
        {
            try
            {
                await this._storage.RemoveDataset(this.datasetName);
                new Snack("Dataset deleted");
                window.location.hash = "admin/database";
            }
            catch (error: any)
            {
                console.error(error);
                new Snack("Dataset deletion failed", error.message, { autoCloseTimeout: 0 });
            }
        }
    }
}
